import { createAction } from 'redux-act';
import fetch from 'axios';
// eslint-disable-next-line import/no-unresolved
import { push } from 'connected-react-router';

/**
 * Create the action
 */

const request = createAction('TRAINING_INTEREST_REQUEST');
const success = createAction('TRAINING_INTEREST_SUCCESS');
const error = createAction('TRAINING_INTEREST_ERROR');

function storeInterest(data) {
    return function (dispatch) {
        // Dispatch the request action
        dispatch(request);

        return fetch
            .post(`/api/trainings/interest/${data.id}`, data)
            .then(({ response }) => {
                /* dispatch(notify({
                    message: 'Account aangemaakt!',
                    dismissible: true,
                    status: 'success',
                    position: 'tc'
                })); */

                // Dispatch success action
                dispatch(success(response));
            })
            .catch((err) => {
                /*
                dispatch(notify({
                    message: 'Zorg ervoor dat alle velden zijn ingevuld.',
                    dismissible: true,
                    status: 'error',
                    position: 'tc'
                })); */
                dispatch(error(err));
                throw err;
            });
    };
}

/**
 * Export the components
 */

export { storeInterest as default };
export { request, success, error };
